import { api } from "../api";

/**
 * interestPointFindAllExportResponse - Function that finds on database all interest points by customer and status and then exports in a PDF/XSLX file
 * /interest-points/{customerId}/{status}/{exportType}/export
 * method GET
 * @async-function
 */
const interestPointFindAllExportResponse = async (
    token: string,
    customerId: number,
    status: string,
    exportType: string,
    simpleXlsxExport = false
) => {
    const response = await api.get(
        `/interest-points/${customerId}/${status}/${exportType}/export?simple=${simpleXlsxExport}`,
        {
            responseType: "arraybuffer",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default interestPointFindAllExportResponse;
